import { Icon } from "@/components/icon/Icon";

interface NavigationControlsProps {
  currentIndex: number;
  totalCount: number;
  isActive: boolean;
  onPrevious: () => void;
  onNext: () => void;
  compact?: boolean; // For responsive sizing
}

export function NavigationControls({
  currentIndex,
  totalCount,
  isActive,
  onPrevious,
  onNext,
  compact = false,
}: NavigationControlsProps) {
  const buttonClass = `font-medium ${compact ? "px-4 md:px-1 lg:px-3" : "px-4"} py-2 rounded-lg transition-colors flex items-center gap-2 ${
    isActive
      ? "text-primary-600 hover:text-primary-700 hover:bg-primary-25 cursor-pointer"
      : "text-gray-400 cursor-pointer disabled"
  }`;

  const textClass = compact
    ? "text-sm md:text-xs lg:text-xs xl:text-sm"
    : "text-sm";

  const counterClass = `${compact ? "px-4 md:px-3" : "px-4"} py-2 rounded-full ${compact ? "text-sm md:text-xs lg:text-xs xl:text-sm" : "text-sm"} font-medium transition-colors ${
    isActive ? "bg-primary-25 text-primary-700" : "bg-gray-100 text-gray-400"
  }`;

  return (
    <div className="flex items-center justify-between">
      {/* Previous Button or Spacer */}
      <div className="flex-1">
        {currentIndex > 0 && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onPrevious();
            }}
            className={buttonClass}
          >
            <Icon name="arrow-left" size="medium" />
            <span className={textClass}>Previous</span>
          </button>
        )}
      </div>

      {/* Counter */}
      <div className={counterClass}>
        {currentIndex + 1}/{totalCount}
      </div>

      {/* Next Button or Spacer */}
      <div className="flex-1 flex justify-end">
        {currentIndex < totalCount - 1 && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onNext();
            }}
            className={buttonClass}
          >
            <span className={textClass}>Next</span>
            <Icon name="arrow-right" size="medium" />
          </button>
        )}
      </div>
    </div>
  );
}
